import { render } from "./ActivateEmailComponent.vue?vue&type=template&id=52f7c092&scoped=true"
import script from "./ActivateEmailComponent.vue?vue&type=script&lang=js"
export * from "./ActivateEmailComponent.vue?vue&type=script&lang=js"

import "./ActivateEmailComponent.vue?vue&type=style&index=0&id=52f7c092&scoped=true&lang=scss"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52f7c092"]])

export default __exports__